import {ArtifactsController} from '@mintdata-wsp/common/controllers/artifacts/ArtifactsController';
import {
    AnalyticsControllers,
    AssetsControllers,
    commonControllers,
    SpreadsheetControllers
} from '@mintdata-wsp/common/controllers/CommonControllers';
import {FilesController} from '@mintdata-wsp/common/controllers/files/FilesController';
import {FlowSimulationController} from '@mintdata-wsp/common/controllers/flow/FlowSimulationController';
import {FlowSimulationStatusController} from '@mintdata-wsp/common/controllers/flow/FlowSimulationStatusController';
import {SurfaceDnDController} from '@mintdata-wsp/common/controllers/surface/SurfaceDnDController';
import {ConfigUtil} from '@mintdata-wsp/common/util/ConfigUtil';
import {WindowLocationUtil} from '@mintdata-wsp/common/util/WindowLocationUtil';
import {AnyPageController} from '@mintdata-wsp/wsp/controllers/common/AnyPageController';
import {DialogsController} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import {ToastController} from '@mintdata-wsp/wsp/controllers/common/ToastController';
import {WspApplicationContextController} from '@mintdata-wsp/wsp/controllers/context/WspApplicationContextController';
import {FeatureController} from '@mintdata-wsp/wsp/controllers/feature/FeatureController';
import {DesignSyncController} from '@mintdata-wsp/wsp/controllers/multiplayer/DesignSyncController';
import {LazyValuesSyncController} from '@mintdata-wsp/wsp/controllers/multiplayer/LazyValuesSyncController';
import {ActiveUsersSyncController} from '@mintdata-wsp/wsp/controllers/multiplayer/ActiveUsersSyncController';
import {MultiplayerController} from '@mintdata-wsp/wsp/controllers/multiplayer/MultiplayerController';
import {ReconnectionController} from '@mintdata-wsp/wsp/controllers/multiplayer/ReconnectionController';
import {CloudComponentsLoader} from '@mintdata-wsp/wsp/controllers/visualDesigner/artifacts/CloudComponentsLoaderRemote';
import {WspBindingsController} from '@mintdata-wsp/wsp/controllers/visualDesigner/bindings/WspBindingsController';
import {CommandMenuController} from '@mintdata-wsp/wsp/controllers/visualDesigner/CommandMenuController';
import {CopyPagesController} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/CopyPagesController';
import {DesignMigrationController} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {DesignVersionsController} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignVersionsController';
import {OpenDesignController} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/OpenDesignController';
import {SampleDesignController} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/SampleDesignController';
import {GuideController} from '@mintdata-wsp/wsp/controllers/visualDesigner/guide/GuideController';
import {PublishController} from '@mintdata-wsp/wsp/controllers/visualDesigner/launch/PublishController';
import {CellSettingsBarController} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/CellSettingsBarController';
import {FrameDetailsController} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/FrameDetailsController';
import {MeshCellNoteController} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/mesh/MeshCellNoteController';
import {MeshCellSettingsController} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/mesh/MeshCellSettingsController';
import {MeshController} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/mesh/MeshController';
import {MeshCopyPasteController} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/mesh/MeshCopyPasteController';
import {MeshInputController} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/mesh/MeshInputController';
import {MeshKeyboardController} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/mesh/MeshKeyboardController';
import {MeshMouseController} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/mesh/MeshMouseController';
import {MeshSelectionController} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/mesh/MeshSelectionController';
import {SheetSettingsController} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/SheetSettingsController';
import {SpreadsheetsMainController} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/SpreadsheetsMainController';
import {TopFormulaEditorController} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/TopFormulaEditorController';
import {WorkbookController} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/WorkbookController';
import {TopMenuController} from '@mintdata-wsp/wsp/controllers/visualDesigner/TopMenuController';
import {UndoRedoController} from '@mintdata-wsp/wsp/controllers/visualDesigner/UndoRedoController';
import {GridMeasureController} from '@mintdata-wsp/wsp/controllers/visualDesigner/util/GridMeasureController';
import {VisualDataController} from '@mintdata-wsp/wsp/controllers/visualDesigner/visualData/VisualDataController';
import {ComponentIconsController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/ComponentIconsController';
import {FlowBindingsController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/flow/FlowBindingsController';
import {FlowCanvasController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/flow/FlowCanvasController';
import {FlowCanvasKeyboardController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/flow/FlowCanvasKeyboardController';
import {FlowComponentsPanelController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/flow/FlowComponentsPanelController';
import {FlowDataPanelsController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/flow/FlowDataPanelsController';
import {FlowEventsController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/flow/FlowEventsController';
import {FlowKeyboardController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/flow/FlowKeyboardController';
import {FlowPropertiesPanelController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/flow/FlowPropertiesPanelController';
import {FlowSelectionController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/flow/FlowSelectionController';
import {FlowSimulationMessagesController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/flow/FlowSimulationMessagesController';
import {FlowTopBarController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/flow/FlowTopBarController';
import {FlowValidationController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/flow/FlowValidationController';
import {FlowWiresController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/flow/FlowWiresController';
import {WspFlowCloudController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/flow/WspFlowCloudController';
import {WspFlowController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/flow/WspFlowController';
import {KeyboardController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/KeyboardController';
import {FullScreenController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/layout/FullScreenController';
import {PerspectiveController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/layout/PerspectiveController';
import {LearnExperienceController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/LearnExperienceController';
import {CodeEditorController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/panels/codeEditor/CodeEditorController';
import {ConsolePanelController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/panels/console/ConsolePanelController';
import {ProblemsPanelController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/panels/errors/ProblemsPanelController';
import {GeneralPanelsController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/panels/GeneralPanelsController';
import {SurfaceAreaController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/surface/SurfaceAreaController';
import {SurfaceMovingController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/surface/SurfaceMovingController';
import {SurfaceBoxReparentingController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/surface/SurfaceBoxReparentingController';
import {SurfaceDrawingComponentController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/surface/SurfaceDrawingComponentController';
import {SurfaceFileUploadController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/surface/SurfaceFileUploadController';
import {SurfaceGlassController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/surface/SurfaceGlassController';
import {SurfaceGuidelinesController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/surface/SurfaceGuidelinesController';
import {SurfaceKeyboardController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/surface/SurfaceKeyboardController';
import {SurfacePagesPanelController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/surface/SurfacePagesPanelController';
import {SurfacePropertiesPanelController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/surface/SurfacePropertiesPanelController';
import {SurfaceSelectionController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/surface/SurfaceSelectionController';
import {WorkbenchController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/WorkbenchController';
import {WorkbenchVisibilityController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/WorkbenchVisibilityController';
import {InviteController} from '@mintdata-wsp/wsp/controllers/workspace/auth/InviteController';
import {JoinController} from '@mintdata-wsp/wsp/controllers/workspace/auth/JoinController';
import {LoginController} from '@mintdata-wsp/wsp/controllers/workspace/auth/LoginController';
import {NewPasswordController} from '@mintdata-wsp/wsp/controllers/workspace/auth/NewPasswordController';
import {ProfileController} from '@mintdata-wsp/wsp/controllers/workspace/auth/ProfileController';
import {ResetPasswordController} from '@mintdata-wsp/wsp/controllers/workspace/auth/ResetPasswordController';
import {SignUpController} from '@mintdata-wsp/wsp/controllers/workspace/auth/SignUpController';
import {UserController} from '@mintdata-wsp/wsp/controllers/workspace/auth/UserController';
import {DesignsController} from '@mintdata-wsp/wsp/controllers/workspace/home/DesignsController';
import {MainPageController} from '@mintdata-wsp/wsp/controllers/workspace/home/MainPageController';
import {OrganizationsController} from '@mintdata-wsp/wsp/controllers/workspace/home/OrganizationsController';
import {ProjectsController} from '@mintdata-wsp/wsp/controllers/workspace/home/ProjectsController';
import {SnippetsController} from '@mintdata-wsp/wsp/controllers/workspace/home/SnippetsController';
import {TemplatesController} from '@mintdata-wsp/wsp/controllers/workspace/home/TemplatesController';
import {NavigationController} from '@mintdata-wsp/wsp/controllers/workspace/NavigationController';
import {PublishedAppsController} from '@mintdata-wsp/wsp/controllers/workspace/publishedApps/PublishedAppsController';
import {BillingController} from '@mintdata-wsp/wsp/controllers/workspace/settings/BillingController';
import {CredentialsController} from '@mintdata-wsp/wsp/controllers/workspace/settings/CredentialsController';
import {MembersController} from '@mintdata-wsp/wsp/controllers/workspace/settings/MembersController';
import {InvoicesController} from '@mintdata-wsp/wsp/controllers/workspace/settings/storefront/InvoicesController';
import {PaymentMethodController} from '@mintdata-wsp/wsp/controllers/workspace/settings/storefront/PaymentMethodController';
import {ProductSelectionController} from '@mintdata-wsp/wsp/controllers/workspace/settings/storefront/ProductSelectionController';
import {StorefrontController} from '@mintdata-wsp/wsp/controllers/workspace/settings/StorefrontController';
import {SmartPatchController} from '@mintdata-wsp/wsp/controllers/multiplayer/SmartPatchController';
import {DesignUIStateControler} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignUIStateController';
import {Logger} from '@mintdata/mint-kit/api/log/mk';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';
import _merge from 'lodash/merge';

export class NetworkControllers
{
    public readonly profile:ProfileController = new ProfileController();
    public readonly invite:InviteController = new InviteController();
    public readonly billing:BillingController = new BillingController();
    public readonly reconnection:ReconnectionController = new ReconnectionController();
}

export class DataControllers
{
    public readonly organizations:OrganizationsController = new OrganizationsController();
    public readonly designs:DesignsController = new DesignsController();
    public readonly projects:ProjectsController = new ProjectsController();
    public readonly templates:TemplatesController = new TemplatesController();
    public readonly snippets:SnippetsController = new SnippetsController();
    public readonly storefront:StorefrontController = new StorefrontController();

    public readonly credentials:CredentialsController = new CredentialsController();
}

export class PanelControllers
{
    public readonly general:GeneralPanelsController = new GeneralPanelsController();
    public readonly console:ConsolePanelController = new ConsolePanelController();
    public readonly problems:ProblemsPanelController = new ProblemsPanelController();
    public readonly codeEditor:CodeEditorController = new CodeEditorController();
}

export class WspSpreadsheetControllers extends SpreadsheetControllers
{
    public readonly topFormulaEditor:TopFormulaEditorController = new TopFormulaEditorController();
    public readonly cellSettingsBar:CellSettingsBarController = new CellSettingsBarController();

    public readonly workbook:WorkbookController = new WorkbookController();
    public readonly main:SpreadsheetsMainController = new SpreadsheetsMainController();
    // public readonly cloudSheet:CloudSheetController = new CloudSheetController();
    // public readonly cloudSheetCopyPaste:CloudSheetCopyPasteController = new CloudSheetCopyPasteController();

    public readonly mesh:MeshController = new MeshController();
    public readonly meshKeyboard:MeshKeyboardController = new MeshKeyboardController();
    public readonly meshInput:MeshInputController = new MeshInputController();
    public readonly meshCopyPaste:MeshCopyPasteController = new MeshCopyPasteController();
    public readonly meshMouse:MeshMouseController = new MeshMouseController();
    public readonly meshSelection:MeshSelectionController = new MeshSelectionController();
    public readonly meshCellSettings:MeshCellSettingsController = new MeshCellSettingsController();
    public readonly meshNote:MeshCellNoteController = new MeshCellNoteController();

    // public readonly importTabs:ImportTabsController = new ImportTabsController();

    // View: SheetSettings
    public readonly sheetSettings:SheetSettingsController = new SheetSettingsController();
    // public readonly cloudSheetSettings:CloudSheetSettingsController = new CloudSheetSettingsController();

    // View: Frame Details
    public readonly frameDetails:FrameDetailsController = new FrameDetailsController();
}

export class UIControllers
{
    // common controllers
    public readonly artifacts:ArtifactsController;
    public readonly assets:AssetsControllers;
    public readonly files:FilesController;

    // wsp controllers
    public readonly migration:DesignMigrationController = new DesignMigrationController();
    public readonly openDesign:OpenDesignController = new OpenDesignController();
    public readonly sampleDesign:SampleDesignController = new SampleDesignController();
    public readonly bindings:WspBindingsController = new WspBindingsController();
    public readonly spreadsheets:WspSpreadsheetControllers = new WspSpreadsheetControllers();
    public readonly designVersions:DesignVersionsController = new DesignVersionsController();
    public readonly guide:GuideController = new GuideController();

    public readonly anyPage:AnyPageController = new AnyPageController();
    public readonly dialogs:DialogsController = new DialogsController();
    public readonly mainPage:MainPageController = new MainPageController();
    public readonly productSelection:ProductSelectionController = new ProductSelectionController();
    public readonly paymentMethod:PaymentMethodController = new PaymentMethodController();
    public readonly invoices:InvoicesController = new InvoicesController();
    public readonly publishedApps:PublishedAppsController = new PublishedAppsController();
    public readonly copyPages:CopyPagesController = new CopyPagesController();

    public readonly members:MembersController = new MembersController();

    public readonly visualData:VisualDataController = new VisualDataController();
    public readonly publish:PublishController = new PublishController();

    public readonly login:LoginController = new LoginController();
    public readonly signUp:SignUpController = new SignUpController();
    public readonly join:JoinController = new JoinController();
    public readonly resetPassword:ResetPasswordController = new ResetPasswordController();
    public readonly newPassword:NewPasswordController = new NewPasswordController();

    public readonly workbench:WorkbenchController = new WorkbenchController();
    public readonly workbenchVisibility:WorkbenchVisibilityController = new WorkbenchVisibilityController();
    public readonly keyboard:KeyboardController = new KeyboardController();
    public readonly componentIcons:ComponentIconsController = new ComponentIconsController();
    public readonly perspective:PerspectiveController = new PerspectiveController();
    public readonly fullScreen:FullScreenController = new FullScreenController();
    public readonly panels:PanelControllers = new PanelControllers();

    public readonly lx:LearnExperienceController = new LearnExperienceController();

    public readonly multiplayer:MultiplayerController = new MultiplayerController();
    public readonly designSync:DesignSyncController = new DesignSyncController();
    public readonly lazyValuesSync:LazyValuesSyncController = new LazyValuesSyncController();
    public readonly activeUsersSync:ActiveUsersSyncController = new ActiveUsersSyncController();
    public readonly smartPatch:SmartPatchController = new SmartPatchController();
    public readonly designUIState:DesignUIStateControler = new DesignUIStateControler();

    public readonly flow:WspFlowController = new WspFlowController();
    public readonly flowCloud:WspFlowCloudController = new WspFlowCloudController();
    public readonly flowSimulation:FlowSimulationController;
    public readonly flowSimulationStatus:FlowSimulationStatusController;
    public readonly flowSimulationMessages:FlowSimulationMessagesController = new FlowSimulationMessagesController();
    public readonly flowTopBar:FlowTopBarController = new FlowTopBarController();
    public readonly flowCanvas:FlowCanvasController = new FlowCanvasController();
    public readonly flowWires:FlowWiresController = new FlowWiresController();
    public readonly flowSelection:FlowSelectionController = new FlowSelectionController();
    public readonly flowValidation:FlowValidationController = new FlowValidationController();
    public readonly flowDataPanels:FlowDataPanelsController = new FlowDataPanelsController();
    public readonly flowComponentsPanel:FlowComponentsPanelController = new FlowComponentsPanelController();
    public readonly flowPropertiesPanel:FlowPropertiesPanelController = new FlowPropertiesPanelController();
    public readonly flowBindings:FlowBindingsController = new FlowBindingsController();
    public readonly flowEvents:FlowEventsController = new FlowEventsController();
    public readonly flowKeyboard:FlowKeyboardController = new FlowKeyboardController();
    public readonly flowCanvasKeyboard:FlowCanvasKeyboardController = new FlowCanvasKeyboardController();

    public readonly surfaceArea:SurfaceAreaController = new SurfaceAreaController();
    public readonly surfaceGlass:SurfaceGlassController = new SurfaceGlassController();
    public readonly surfaceDnD:SurfaceDnDController = new SurfaceDnDController();
    public readonly surfaceKeyboard:SurfaceKeyboardController = new SurfaceKeyboardController();
    public readonly surfaceGuidelines:SurfaceGuidelinesController = new SurfaceGuidelinesController();
    public readonly surfaceSelection:SurfaceSelectionController = new SurfaceSelectionController();
    public readonly surfaceMoving:SurfaceMovingController = new SurfaceMovingController();
    public readonly surfaceBoxReparenting:SurfaceBoxReparentingController = new SurfaceBoxReparentingController();
    public readonly surfaceDrawingComponent:SurfaceDrawingComponentController = new SurfaceDrawingComponentController();
    public readonly surfacePropertiesPanel:SurfacePropertiesPanelController = new SurfacePropertiesPanelController();
    public readonly surfacePagesPanel:SurfacePagesPanelController = new SurfacePagesPanelController();
    public readonly surfaceFileUpload:SurfaceFileUploadController = new SurfaceFileUploadController();

    public readonly gridMeasure:GridMeasureController = new GridMeasureController();

    public readonly undoRedo:UndoRedoController = new UndoRedoController();

    public readonly toasts:ToastController = new ToastController();

    public readonly commandMenu:CommandMenuController = new CommandMenuController();

    public readonly topMenu:TopMenuController = new TopMenuController();
}

export class WspControllers
{
    // User & Navigation
    public readonly user:UserController = new UserController();
    public readonly navigation:NavigationController = new NavigationController();

    // Network & Data
    public readonly net:NetworkControllers = new NetworkControllers();
    public readonly data:DataControllers = new DataControllers();

    // Common stuff
    public readonly context:WspApplicationContextController = new WspApplicationContextController();
    public readonly feature:FeatureController = new FeatureController();

    // UI
    public readonly ui:UIControllers = new UIControllers();

    // Analytics
    public readonly analytics:AnalyticsControllers = new AnalyticsControllers();

    private _initialized:boolean = false;

    public initialize()
    {
        WindowLocationUtil.setDocumentDomain();

        Assert.no(this._initialized);

        Logger.configure(ConfigUtil.loggingConfig());

        // hippoAPI.init();

        //this is poor-man's DI
        commonControllers.initialize({
            artifacts: new ArtifactsController(
                // VisualComponentFactory.createVisualComponentLoader(),
                new CloudComponentsLoader()
            ),

            bindings: this.ui.bindings,
            flow: this.ui.flow,
            flowCloud: this.ui.flowCloud,
            spreadsheets: {
                main: this.ui.spreadsheets.main,
                mesh: this.ui.spreadsheets.mesh,
                sheet: this.ui.spreadsheets.sheet,
                sheetSettings: this.ui.spreadsheets.sheetSettings
            },
            context: this.context
        });

        //this is just for convenience - to just use wspControllers most of the time and not even import commonControllers
        _merge(this, {
            ui: {
                artifacts: commonControllers.artifacts,
                assets: {
                    graphics: commonControllers.assets.graphics,
                    icons: commonControllers.assets.icons,
                    illustrations1: commonControllers.assets.illustrations1,
                    illustrations2: commonControllers.assets.illustrations2,
                    uploadedImages: commonControllers.assets.uploadedImages,
                    fonts: commonControllers.assets.fonts
                },
                files: commonControllers.files,
                spreadsheets: {
                    namedRanges: commonControllers.spreadsheets.namedRanges,
                    clientFunctions: commonControllers.spreadsheets.clientFunctions
                },
                flowSimulation: commonControllers.flowSimulation,
                flowSimulationStatus: commonControllers.flowSimulationStatus
            },
            analytics: commonControllers.analytics
        });

        commonControllers.hostContext.init();

        commonControllers.buildVersion.init();
        commonControllers.flowCloud.init();

        commonControllers.assets.fonts.init();

        this.user.init();
        this.data.projects.init();
        // this.data.snippets.init();

        this.net.reconnection.init();
        this.ui.lazyValuesSync.init();
        this.ui.activeUsersSync.init();
        this.ui.openDesign.init();
        // this.ui.designVersions.init();

        this.ui.spreadsheets.main.init();
        // this.ui.spreadsheets.cloudSheet.init();
        this.ui.spreadsheets.frameDetails.init();
        this.ui.spreadsheets.clientFunctions.init();

        this.ui.keyboard.init();
        this.ui.members.init();
        this.ui.publish.init();

        this.ui.perspective.init();

        this.ui.flowTopBar.init();
        this.ui.flowCanvas.init();
        this.ui.flowDataPanels.init();
        this.ui.flowPropertiesPanel.init();
        this.ui.flowKeyboard.init();
        this.ui.flowCanvasKeyboard.init();

        this.ui.surfaceKeyboard.init();
        this.ui.surfacePagesPanel.init();

        this.ui.panels.console.init();
        this.ui.panels.problems.init();
        this.ui.panels.codeEditor.init();

        this.ui.lx.init();

        this.ui.fullScreen.init();
        this.ui.login.init();
        this.ui.commandMenu.init();

        this._initialized = true;
    }
}

export const controllers:WspControllers = new WspControllers();
